import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const DIR_SPORTS = ["Archery", "Badminton", "Baseball", "Basketball", "Bowling", "Boxing", "Cricket", "Cycling", "Football", "Futsal", "Golf",
  "Martial Arts", "Multi-Sport", "Netball", "Padel", "Pickleball", "Squash", "Swimming", "Table Tennis", "Tennis", "Volleyball"];
export const STATES = ["Johor", "Kedah", "Kelantan", "Kuala Lumpur", "Labuan", "Melaka", "Negeri Sembilan", "Pahang", "Penang", "Perak", "Perlis",
  "Putrajaya", "Sabah", "Sarawak", "Selangor", "Shah Alam", "Petaling Jaya", "Subang Jaya", "Terengganu"];
export const SKILLS = ["Any", "Beginner", "Intermediate", "Advanced"];

export const viewerId = () => {
  let v = localStorage.getItem("asv_viewer");
  if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("asv_viewer", v); }
  return v;
};

export const trackClick = (campaignId) => { if (campaignId) api.post(`/asv/ads/${campaignId}/click`, { viewer: viewerId() }).catch(() => {}); };

// ---------- Cart (one vendor at a time, stored per browser) ----------
const CART_KEY = "asv_cart";
const readCart = () => { try { return JSON.parse(localStorage.getItem(CART_KEY)) || { vendor_slug: "", vendor_name: "", items: [] }; } catch { return { vendor_slug: "", vendor_name: "", items: [] }; } };
const writeCart = (c) => { localStorage.setItem(CART_KEY, JSON.stringify(c)); window.dispatchEvent(new Event("asv-cart")); };
export const sameSlot = (a, b) => a.pitch_id === b.pitch_id && a.date === b.date && a.slot_start === b.slot_start;

export function useCart() {
  const [cart, setCart] = useState(readCart);
  useEffect(() => {
    const on = () => setCart(readCart());
    window.addEventListener("asv-cart", on);
    window.addEventListener("storage", on);
    return () => { window.removeEventListener("asv-cart", on); window.removeEventListener("storage", on); };
  }, []);
  const add = useCallback((vendor, item) => {
    const c = readCart();
    if (c.items.length && c.vendor_slug !== vendor.slug) return false;
    if (!c.items.some((i) => sameSlot(i, item))) writeCart({ vendor_slug: vendor.slug, vendor_name: vendor.name, items: [...c.items, item] });
    return true;
  }, []);
  const remove = useCallback((item) => { const c = readCart(); writeCart({ ...c, items: c.items.filter((i) => !sameSlot(i, item)) }); }, []);
  const clear = useCallback(() => writeCart({ vendor_slug: "", vendor_name: "", items: [] }), []);
  return { cart, add, remove, clear };
}

// ---------- Theme ----------
export function useAsvTheme() {
  const [dark, setDark] = useState(() => localStorage.getItem("asv_theme") === "dark");
  useEffect(() => { localStorage.setItem("asv_theme", dark ? "dark" : "light"); }, [dark]);
  return [dark, setDark];
}

// ---------- Player session ----------
const PlayerCtx = createContext({ player: undefined, unread: 0, refresh: () => {}, logout: () => {} });
export const usePlayer = () => useContext(PlayerCtx);

export function PlayerProvider({ children }) {
  const [state, setState] = useState({ player: undefined, unread: 0 });
  const refresh = useCallback(() => api.get("/asv/me").then((r) => setState({ player: r.data.player, unread: r.data.unread })).catch(() => setState({ player: null, unread: 0 })), []);
  const logout = useCallback(() => api.post("/asv/auth/logout").finally(() => setState({ player: null, unread: 0 })), []);
  useEffect(() => { refresh(); }, [refresh]);
  return <PlayerCtx.Provider value={{ ...state, refresh, logout }}>{children}</PlayerCtx.Provider>;
}

export const listParams = (sp) => Object.fromEntries([...sp.entries()].filter(([, v]) => v !== ""));
